import React, { useEffect, useState } from 'react';
import '../assets/css/blog.css';
import '../assets/css/custom.css';
import bgImage from '../assets/Images/homeBackgroundImg.png';
import blogImg from '../assets/Images/blog.png';

import API_BASE_URL from "../../helper";
function Blog() {

    const [blogs, setBlogs] = useState([]);
    
    // Fetch All Blogs
    const fetchAllBlogs = async () => {
        try {
        const response = await fetch(`${API_BASE_URL}/api/blog/all`);
        const data = await response.json();
        setBlogs(data);
        } catch (error) {
        console.error("Failed to load Blogs", error);
        }
    };
    useEffect(() => {
      fetchAllBlogs();
    }, []);

  return (
  <div>
    <div id="blog-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">Our Blogs</h2>
        <p className='hero-subheading'>Stay updated with the latest insights, trends, and ideas in
technology and business.</p>
    </div>

    <section id='blogSection' className='mt-5'>
        <div className='container'>
            <h2 className='blogHeading'>Explore a range of perspectives from EZIO experts on key topics for business, technology and society.</h2>
        
            <div className='row mt-5'>

                {blogs.length > 0 ? (
                    blogs.map((blog) => (
                    <div className='col-12 mb-3' key={blog.id}>
                        <div className='row'>
                            <div className='col-md-4'>
                                <img className='blogImg' src={`${API_BASE_URL}/assets/Images/${blog.image}`} alt="loading"></img>
                            </div>
                            <div className='col-md-8'>
                                <p className='fw-semibold'>{blog.heading}</p>
                                <h3 className='blogTitle'>{blog.subHeading}</h3>
                                {/* <a href='/readBlog' className='btn btn-outline-dark text-black blogRead'>Read More <i class="blogRightArrow fa-solid fa-arrow-right"></i></a> */}
                                <a href={`/readBlog/${blog.id}`} 
                                    className='btn btn-outline-dark text-black blogRead'>
                                    Read More <i class="fa-solid fa-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    ))
                ) : (
                    <p>No Blogs Available</p>
                )}
            </div>
        </div>
    </section>

  </div>
  )
}

export default Blog;